import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Dollars from '../../Dollars/Dollars'

import { useDeliveryToasts } from './use-delivery-toasts'
import { useLineItems } from '../../../utils/cart-helpers'

import './CartFooter.css'

const CartFooter = ({
  cart,
  deliveryChargeLabel = 'Delivery Cost',
  showTotal = false,
  showTip = false,
  tip = null
}) => {
  const getLineItems = useLineItems({
    cart,
    showTip,
    showTotal,
    deliveryChargeLabel
  })
  useDeliveryToasts({ cart })
  const lineItems = getLineItems(tip)
  return (
    <div styleName='footer' data-testid='total-amounts'>
      <table>
        <tfoot>
          {lineItems.map(({ label, amount, id }) => (
            <tr
              data-testid={id}
              key={id}
              styleName={cx({
                total:
                  id === 'total-order-remaining-amount' ||
                  id === 'total-order-amount'
              })}
            >
              <td>{label}</td>
              <td>
                <Dollars
                  amount={Number(amount) || 0}
                  renderWhenZero={
                    id === 'deliveryChargeTotal-amount' ? 'Free' : undefined
                  }
                />
              </td>
            </tr>
          ))}
        </tfoot>
      </table>
    </div>
  )
}

CartFooter.propTypes = {
  cart: PropTypes.object.isRequired,
  /** Override the default label when displaying a delivery charge line item */
  deliveryChargeLabel: PropTypes.node,
  showTotal: PropTypes.bool,
  showTip: PropTypes.bool,
  tip: PropTypes.number
}

export default CartFooter
